import Link from 'next/link';
import React from 'react';
import { Resource } from '../Models/ResourceProps';
import LargeWidthContainer from '../Layout/Containers/LargeWidthContainer';
import { StrapiImageComponent } from '../util/MediaComponent/MediaComponent';
import styles from '../CustomerCases/customerCases.module.scss';

type InsightsProps = {
    resources: Array<Resource>;
};

const InsightsComponent = ({ resources }: InsightsProps) =>
    resources.length > 0 ? (
        <LargeWidthContainer>
            <section className={styles.customerCases}>
                <div className={styles.header}>
                    <div>
                        <span className={styles.eyebrow}>Insights</span>
                        <h2 className={styles.title}>From the inside of the work.</h2>
                    </div>
                    <Link href="/resources" className={styles.all}>
                        <span>All insights</span>
                        <span aria-hidden="true">&rarr;</span>
                    </Link>
                </div>
                <div className={styles.grid}>
                    {resources.map((resource) => (
                        <Link
                            key={`noria-resource-${resource.seoUrl}`}
                            href={`/resources/${resource.seoUrl}`}
                            className={styles.card}
                            title={`Go to resource page for ${resource.heading}`}
                        >
                            {resource.mainImage ? (
                                <StrapiImageComponent
                                    className={styles.imageWrapper}
                                    strapiImage={resource.mainImage}
                                />
                            ) : (
                                <div className={`${styles.imageWrapper} ${styles.placeholder}`}>
                                    {resource.resource_category?.name}
                                </div>
                            )}
                            {resource.punchline && (
                                <p className={styles.tags}>{resource.punchline}</p>
                            )}
                            <h3 className={styles.name}>{resource.ingress}</h3>
                        </Link>
                    ))}
                </div>
            </section>
        </LargeWidthContainer>
    ) : null;

export default InsightsComponent;
